import React from "react";
import log from "../../images/NEW FATS LOGO.png";
import { Link, useNavigate } from "react-router-dom";
import { I18nextProvider, useTranslation } from "react-i18next";
// import LanguageSwitcher from "../../switer";
import i18n from "../../i18n";
import LanguageSwitcher from "../../switer";

const Header = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-50 bg-white">
      <div>
        <div
          className={`h-auto w-full bg-gray-100 flex flex-col sm:flex-row justify-between items-center px-4 py-4  ${
            i18n.language === "ar" ? "lg:flex-row-reverse" : "lg:flex-row"
          }`}
        >
          {/* Logo and Text */}
          <div
            className={`flex items-center flex-wrap mb-4 sm:mb-0 ${
              i18n.language === "ar" ? "lg:flex-row-reverse" : "lg:flex-row"
            }`}
          >
            <img
              onClick={() => navigate("/")}
              src={log}
              className="h-14 w-auto cursor-pointer"
              alt=""
            />
            <div className="text-center px-2">
              {/* <p className="text-secondary font-semibold">
                {t("GS1 Saudia Arabia")}
              </p> */}
              <p className="text-secondary">
                {t("Fixed Asset Tracking System")}
              </p>
            </div>
          </div>

          {/* Buttons */}
          <div
            className={`flex flex-wrap justify-center my-auto ${
              i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
            }`}
          >
            <div className="">
              {/* <div className="flex justify-end items-end px-1 gap-3 font-sans font-semibold">
                <p
                  onClick={() => navigate("/gepir")}
                  className="text-blue-500 transition-transform transform hover:scale-125 cursor-pointer"
                >
                  {t("Verified By GS1")}
                </p>
                |
                <span
                  onClick={() => navigate("/admin-login")}
                  className="text-blue-500 transition-transform transform hover:scale-125 cursor-pointer"
                >
                  {t("Staff Login")}
                </span>
              </div> */}
              <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2">
                <button
                  onClick={() => navigate("/userlogin")}
                  className="bg-[#1d2331] text-white px-8 border border-[#1d2331] hover:bg-white hover:text-[#2b4892] hover:bottom-[#1d2331] py-1 text-lg font-bold  rounded-md transition-all duration-300  transform "
                >
                  {t("Login")}
                </button>

                <button
                  onClick={() => navigate("/contactus")}
                  className="bg-[#f0452b] text-white mx-3 px-8 border border-[#f0452b] hover:bg-[#2b4892] hover:border-[#2b4892]  py-1 text-lg font-bold  rounded-md transition-all duration-300  transform "
                >
                  {t("Get a Demo")}
                </button>
                {/* <Link to={`/contactus`} style={{ textDecoration: "none" }}>
                  {t("Get a Demo")}
                </Link> */}
              </div>
            </div>

            <div className="w-full sm:w-auto">
              <I18nextProvider i18n={i18n}>
                <LanguageSwitcher />
              </I18nextProvider>
            </div>
          </div>
        </div>
      </div>
      {/* End Nav */}
    </div>
  );
};

export default Header;
